import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';
import { ts, ts2 } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';

type Props = {
    open: boolean;
    manufacturerName: string;
    disabled?: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const DeleteManufacturerDialog = ({ open, manufacturerName, disabled = false, onClose, onConfirm }: Props) => {
    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={ts('warning', 'Warning!')}
            maxWidth="xs"
            actions={
                <Stack direction="row" justifyContent="center" sx={{ width: '100%', gap: '16%' }}>
                    <Button variant="outlined" onClick={onClose} disabled={disabled} sx={{ minWidth: 100 }}>
                        {ts('plt_cancel', 'Cancel')}
                    </Button>
                    <Button variant="contained" color="error" onClick={onConfirm} disabled={disabled} sx={{ minWidth: 100 }}>
                        {ts('plt_ok', 'OK')}
                    </Button>
                </Stack>
            }
        >
            <Stack spacing={1.5}>
                <Typography variant="body2" color={theme.palette.text.secondary}>
                    {ts2('q_manu_del_pls', 'Please confirm deleting {manufacturer} by clicking OK button below.', {
                        manufacturer: manufacturerName,
                    })}
                </Typography>
                <Typography variant="body2" color={theme.palette.error.main}>
                    {ts('q_manu_del_warn', 'Please note that this will delete all products assigned with this manufacturer.')}
                </Typography>
            </Stack>
        </BaseDialog>
    );
};
